import { Fragment } from 'react';

import useClubNonAthleteRosterFormGrid from './UseClubNonAthleteRosterFormGrid';

import ClubNonAthleteRosterFilterForm from './ClubNonAthleteRosterFilterForm';

import ClubNonAthleteRosterFormGridLarge from './ClubNonAthleteRosterFormGridLarge';
import ClubNonAthleteRosterFormGridSmall from './ClubNonAthleteRosterFormGridSmall';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import useExpandedRow from '@usas/ui-web/components/grids/UseExpandedRow';

import { formatMultipleValuesForDisplay } from '@usas/ui-web/components/table/utils/TableUtils';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const ClubNonAthleteRosterFormGrid = ({ gridData, orgUnitId, isLoading, onEditNonAthlete,
  onSubmitNonAthleteFilter, onSubmitNonAthleteSync, onSubmitNonAthleteTransfer, onErrorCaught = undefined,
  PRACTICE_GROUP_TYPE_ID, SITE_GROUP_TYPE_ID }) => {
  const { expandedId, onClick } = useExpandedRow();
  const {
    displayTransferPopup,
    formGridState,
    selectedNonAthletesState,
    onClearFilterClicked,
    onSyncSelectedClicked,
    onTransferSelectedClicked,
    onTransferPopupConfirmClicked,
    onTransferPopupCancelClicked,
    onUpdateIsSyncSelected,
    onUpdateIsTransferSelected
  } = useClubNonAthleteRosterFormGrid(gridData, onSubmitNonAthleteFilter, onSubmitNonAthleteSync, onSubmitNonAthleteTransfer, onErrorCaught);

  return (
    <Fragment>
      <div className="row usas-extra-bottom-margin">
        <div className="col-xs-12">
          <ClubNonAthleteRosterFilterForm
            orgUnitId={orgUnitId}
            nonAthletesToSyncCount={selectedNonAthletesState.nonAthletesToSync.length}
            nonAthletesToTransferCount={selectedNonAthletesState.nonAthletesToTransfer.length}
            onSubmitNonAthleteFilter={onSubmitNonAthleteFilter}
            onClearNonAthleteFilter={onClearFilterClicked}
            onSubmitNonAthleteSync={onSyncSelectedClicked}
            onSubmitNonAthleteTransfer={onTransferSelectedClicked}
            PRACTICE_GROUP_TYPE_ID={PRACTICE_GROUP_TYPE_ID}
            SITE_GROUP_TYPE_ID={SITE_GROUP_TYPE_ID} />
        </div>
      </div>
      <div className="row usas-extra-top-margin usas-extra-bottom-margin">
        <div className="col-xs-12">
          {isLoading === false
            ? (
              <div className="row">
                <div className="col-xs-12">
                  {gridData.length > 499
                    ? <p className={global.ErrorMessage}>More than 500 Non Athletes returned. Please add additional filters to narrow your results.</p>
                    : <p>{gridData.length === 1 ? `${gridData.length} Non Athlete` : `${gridData.length} Non Athletes`}</p>
                  }
                </div>
              </div>
            ) : <Fragment><div className="row usas-extra-top-margin usas-extra-bottom-margin"></div></Fragment>
          }
          <ClubNonAthleteRosterFormGridLarge formGridState={formGridState} isLoading={isLoading} expandedId={expandedId} onEditNonAthlete={onEditNonAthlete} onUpdateIsSyncSelected={onUpdateIsSyncSelected} onUpdateIsTransferSelected={onUpdateIsTransferSelected} onExpandClicked={onClick} />
          <ClubNonAthleteRosterFormGridSmall formGridState={formGridState} isLoading={isLoading} expandedId={expandedId} onEditNonAthlete={onEditNonAthlete} onUpdateIsSyncSelected={onUpdateIsSyncSelected} onUpdateIsTransferSelected={onUpdateIsTransferSelected} onExpandClicked={onClick} />
        </div>
      </div>
      <PopUpModal
        widthPct={90}
        maxWidth={720}
        title={'Transfer Members?'}
        displayPopUp={displayTransferPopup === true}
        onModalCanceled={onTransferPopupCancelClicked}>
        <div className="row">
          <p className="col-xs-12">
            Are you sure you want to transfer the selected members to Unattached? After transferring, they will appear on your roster with a Pending status until the transfer is approved.
            <br /><br />
            <span style={{ fontSize: 20, color: 'darkgrey' }}>
              {formatMultipleValuesForDisplay(selectedNonAthletesState.nonAthletesToTransfer, 'name')}
            </span>
          </p>
        </div>
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="button" onClick={onTransferPopupConfirmClicked}>Yes, Transfer</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onTransferPopupCancelClicked}>Cancel</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
    </Fragment>
  );
};

export default ClubNonAthleteRosterFormGrid;